export const sha256 = async (text:string) => {
  const salt = 'szdfjkh32k4j5'
  const uint8 = new TextEncoder().encode(`${salt}${text}`)
  const digest = await crypto.subtle.digest('SHA-256', uint8)
  return Array.from(new Uint8Array(digest)).map((v) => v.toString(16).padStart(2, '0')).join('')
}
